const findSerialNumber = (index = 0, activePage = 1, limit = 10) => {
  return (activePage - 1) * limit + index + 1;
};

export default findSerialNumber;
